import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { VenueModelResponse } from 'src/app/_models/Venue/VenueModel';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ApiService } from 'src/app/_services/api.service';
import { VenueService } from 'src/app/_services/venue.service';
import { Subscription } from 'rxjs';
import { CompanyModel } from 'src/app/_models/Company/CompanyModel';
import { Operations } from 'src/app/_models/Operations/Operations';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/_services/auth.service';
import { SearchVenuesModel } from "../../_models/Venue/SearchVenuesModel";
import { Router } from '@angular/router';

@Component({
  selector: 'app-venues',
  templateUrl: './venues.component.html',
  styleUrls: ['./venues.component.scss']
})
export class VenuesComponent implements OnInit, OnDestroy {

  @ViewChild("dataContainer") dataContainer: ElementRef;

  venueSubscription: Subscription;
  public venuesList?: VenueModelResponse[] = []
  public company: CompanyModel = {}
  public countryCode: string;
  public companyTypesString: string = ''
  public searchVenuesModel: SearchVenuesModel = new SearchVenuesModel();

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    private venueService: VenueService,
    private messageService: MessageService,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
  ) {
    authService.hideNavigationMenuEventEmitter.emit(false);
   }

  ngOnInit(): void {
    this.getCompanyDetails();
    this.apiService.getVenues(this.searchVenuesModel).subscribe();
    this.fetchVenues();
  }

  getCompanyDetails(): void {
    this.apiService.getCompanyDetails().subscribe((company: CompanyModel)=>{
      this.company = company;
      this.setCountryCode();
    });
  }

  setCountryCode(){
    if(this.company.countryId){
      this.apiService.getallcountrynames().subscribe((countries)=>{
        countries.forEach((element: {countryCode: string; id: string | undefined;}) => {
          if(element.id == this.company.countryId){
            this.countryCode = element.countryCode;
          }
        });
      });
    }
  }

  getBusinesTypesAsString(companyTypes: any): void {
    let temp: string[] = [];
    if (companyTypes !== undefined) {
      companyTypes.forEach((element: { name: string; }) => {
        temp.push(element.name)
      });
    }
    this.companyTypesString = temp.join(', ');
  }

  fetchVenues(): void {
    this.venueSubscription = this.venueService.venuesChanged
      .subscribe(
        (venues: VenueModelResponse[]) => {
          this.venuesList = venues;
          if (this.venueService.getVenuesPageNumber() === 1 && this.dataContainer) {
            this.dataContainer.nativeElement.scrollTo(0, 0);
            this.searchVenuesModel.pageNumber = 1;
          }
        }
      );
    this.venuesList = this.venueService.getVenues();
  }

  loadMoreVenues(): void {
    this.searchVenuesModel.pageNumber = this.searchVenuesModel.pageNumber + 1;
    this.apiService.getVenues(this.searchVenuesModel).subscribe();
  }

  onConfirmToast():void{
    this.router.navigate(['/promoter/company-profile']);
  }
  onRejectToast(): void {
    this.messageService.clear('company-check');
  }

  ngOnDestroy(): void {
    this.venueSubscription.unsubscribe();
  }
}
